import queryString from 'query-string'
import React from 'react'
import { useLocation } from 'react-router-dom'
import {
  INSUFFICIENT_DATA,
  RANKING_MIN_AMOUNT,
  TOP_BREEDS,
  TOP_CUSTOMERS,
  TOP_SERVICES,
  getServicesData
} from './constants'
import { useServicesDetails } from './hooks/useServicesDetails'
import { Button } from '../../../../components/Form'
import Card from '../../../../components/Card'
import BackButton from '../../../../components/BackButton'
import DateHeader from '../components/DateHeader'
import BarChart from '../../../../components/BarChart'
import { functionalitiesHelper } from '../../../../utils/functionalitiesHelper'
import useGoTo from '../../../../hooks/useGoTo'
import * as S from './styles'

const ServicesDetails = () => {
  const { search } = useLocation()
  const goToPage = useGoTo()
  const { getDates } = functionalitiesHelper
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const { monthAndYear, day, fullDate } = getDates(date)
  const servicesDetails = useServicesDetails(professional.id, fullDate, true)
  const servicesData = servicesDetails ? getServicesData(servicesDetails) : []
  const loading = !servicesDetails
  const hasInsufficientData = (ranking) => ranking?.length < RANKING_MIN_AMOUNT
  const header = {
    title: monthAndYear,
    subtitle: `Informações ${sameDate ? 'deste mês' : ''} até o dia ${day}`,
    loading
  }
  const actionButton = (url) => {
    return (
      <Button outline size='medium'
        onClick={() => goToPage(url, `?date=${date}&sameDate=${sameDate}`)}>
        Detalhes
      </Button>
    )
  }
  const insufficientData = ({ icon, title, subtitle }) => {
    return (
      <S.CardWrapper>
        <Card>
          {icon}
          <S.Title>
            {title}
          </S.Title>
          <S.Subtitle>
            {subtitle}
          </S.Subtitle>
        </Card>
      </S.CardWrapper>
    )
  }

  const topCustomersProps = !loading ? TOP_CUSTOMERS(sameDate, servicesData.customers) : {}
  const topServicesProps = !loading ? TOP_SERVICES(sameDate, servicesData.services) : {}
  const topBreedsProps = !loading ? TOP_BREEDS(sameDate, servicesData.breeds) : {}

  return (
    <>
      <BackButton text='Detalhes dos serviços' backPage='/dashboard' paramData={`?date=${date}`} />
      <S.Container>
        <DateHeader {...header} />
        <BarChart loading={loading} {...topServicesProps} />
        {
          (!loading && hasInsufficientData(servicesDetails?.mostSpendingUsers))
            ? insufficientData({ ...INSUFFICIENT_DATA(sameDate, 'customer') })
            : <BarChart customBody={actionButton('/dashboard/services/clients')} loading={loading} {...topCustomersProps} />
        }
        {
          (!loading && hasInsufficientData(servicesDetails?.mostAttendedBreeds))
            ? insufficientData({ ...INSUFFICIENT_DATA(sameDate, 'breed') })
            : <BarChart loading={loading} {...topBreedsProps} />
        }
      </S.Container>
    </>
  )
}

export default ServicesDetails
